import React from 'react';
import { Pagination as RBPagination } from 'react-bootstrap';

import "./pagination-component.css";

export const PaginationControl = ({
    pageIndex = 0,
    between = 3,
    total = 0,
    pageSize,
    changePage = pageNo => console.log(pageNo),
    pageSizes = [],
    resizePage = pageSize => console.log(pageSize),
    next = true,
    last = true,
    ellipsis = 1,
    hidePageSizeSelection,
    isForApproval,
    pageDataCount

}) => {

    const total_pages = Math.ceil(total / pageSize)
    let pageNo = pageIndex + 1;

    between = between < 1 ? 1 : between
    pageNo = (pageNo < 1 ? 1 : pageNo > total_pages ? total_pages : pageNo)
    ellipsis = ellipsis < 1 ? 0 : ellipsis + 2 >= between ? between - 2 : ellipsis

    let positions = Array.from({ length: total_pages }, (_, i) => i)

    const qtd_pages = (between * 2) + 1
    const range = (
        total_pages <= qtd_pages
            // Show active without slice
            ? positions
            : pageNo - 1 <= between
                // Show active in left
                ? positions.slice(0, qtd_pages - (ellipsis > 0 ? ellipsis + 1 : 0))
                : pageNo + between >= total_pages
                    // Show active in right
                    ? positions.slice(total_pages - qtd_pages + (ellipsis > 0 ? ellipsis + 1 : 0), total_pages)
                    // Show active in middle
                    : positions.slice((pageNo - 1) - (between - (ellipsis > 0 ? ellipsis + 1 : 0)), pageNo + (between - (ellipsis > 0 ? ellipsis + 1 : 0)))
    );

    return (
        <div className="pagination-container">
            <RBPagination>
                {
                    last
                    && <RBPagination.First
                        className={`first-link ${pageNo <= 1 ? 'hidden' : ''}`}
                        onClick={() => pageNo > 1 ? changePage(0) : {}}
                        disabled={pageNo <= 1}
                        hidden={pageNo <= 1}
                    />
                }
                {
                    next
                    && <RBPagination.Prev
                        className={`previous-link ${pageNo <= 1 ? 'hidden' : ''}`}
                        onClick={() => pageNo > 1 ? changePage(pageIndex - 1) : {}}
                        disabled={pageNo <= 1}
                        hidden={pageNo <= 1}
                    />
                }
                {
                    total_pages > (between * 2) + 1 && ellipsis > 0
                    && positions.slice(0, pageNo - 1 <= between ? 0 : ellipsis).map(value => {
                        return <RBPagination.Item key={value}
                            onClick={() => value !== pageNo - 1 ? changePage(value) : {}}>
                            {value + 1}
                        </RBPagination.Item>
                    })
                }
                {
                    // Show ellipsis when "page" is bigger than "between"
                    total_pages > (between * 2) + 1 && ellipsis > 0 && pageNo - 1 > between
                    && <RBPagination.Ellipsis disabled />
                }
                {range.map(value => {
                    return <RBPagination.Item active={value === pageNo - 1}
                        key={value}
                        onClick={() => value !== pageNo - 1 ? changePage(value) : {}}>
                        {value + 1}
                    </RBPagination.Item>
                })}
                {
                    // Show ellipsis when "page" is lower than "between"
                    total_pages > (between * 2) + 1 && ellipsis > 0 && pageNo < total_pages - between
                    && <RBPagination.Ellipsis disabled />
                }
                {
                    total_pages > (between * 2) + 1 && ellipsis > 0
                    && positions.slice(pageNo >= total_pages - between ? total_pages : total_pages - ellipsis, total_pages).map(value => {
                        return <RBPagination.Item key={value}
                            onClick={() => value !== pageNo - 1 ? changePage(value) : {}}>
                            {value + 1}
                        </RBPagination.Item>
                    })
                }
                {
                    next
                    && <RBPagination.Next
                        className={`next-link ${pageNo >= total_pages ? 'hidden' : ''}`}
                        onClick={() => pageNo < total_pages ? changePage(pageNo) : {}}
                        disabled={pageNo >= total_pages}
                        hidden={pageNo >= total_pages}
                    />
                }
                {
                    last
                    && <RBPagination.Last
                        className={`end-link ${pageNo >= total_pages ? 'hidden' : ''}`}
                        onClick={() => pageNo < total_pages ? changePage(total_pages - 1) : {}}
                        disabled={pageNo >= total_pages}
                        hidden={pageNo >= total_pages}
                    />
                }
            </RBPagination>
            {
                pageSizes.length > 0 &&
                <>
                    <span className="page-size" hidden={hidePageSizeSelection}>Page Size</span>
                    <select value={pageSize} onChange={(e) => resizePage(e.target.value)} className="pagination-page-sizes" hidden={hidePageSizeSelection}>
                        {
                            pageSizes.map((item, index) => <option key={index} value={item}>{item}</option>)
                        }
                    </select>
                </>
            }
            {
                total > 0 && <span className="total-items">{isForApproval? pageDataCount.toLocaleString() : total.toLocaleString()} results found</span>
            }
        </div>
    )
}